export type AppRoute =
  | { kind: 'local' }
  | { kind: 'login' }
  | { kind: 'signup' }
  | { kind: 'dashboard'; section?: string; workspaceId?: string; siteId?: string }
  | { kind: 'onboarding' }
  | { kind: 'editor'; siteId: string; preview?: boolean }
  | { kind: 'review'; token: string };

export function parseRoute(
  pathname = window.location.pathname,
  search = typeof window !== 'undefined' ? window.location.search : '',
): AppRoute {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/local') return { kind: 'local' };
  if (path === '/login') return { kind: 'login' };
  if (path === '/signup') return { kind: 'signup' };
  if (path === '/dashboard') {
    const query = new URLSearchParams(search);
    const section = query.get('section');
    const workspaceId = query.get('workspace');
    return {
      kind: 'dashboard',
      ...(section ? { section } : {}),
      ...(workspaceId ? { workspaceId } : {}),
    };
  }
  if (path === '/onboarding') return { kind: 'onboarding' };
  if (path === '/account') return { kind: 'dashboard', section: 'account' };
  const workspaceMatch = path.match(/^\/workspace\/([^/]+)$/);
  if (workspaceMatch)
    return { kind: 'dashboard', workspaceId: decodeURIComponent(workspaceMatch[1]) };
  const siteAreaMatch = path.match(
    /^\/site\/([^/]+)\/(cms|forms|automations|analytics|publishing|settings)$/,
  );
  if (siteAreaMatch) {
    const sectionMap: Record<string, string> = {
      cms: 'collections',
      forms: 'forms',
      automations: 'automations',
      analytics: 'analytics',
      publishing: 'websites',
      settings: 'account',
    };
    return {
      kind: 'dashboard',
      section: sectionMap[siteAreaMatch[2]],
      siteId: decodeURIComponent(siteAreaMatch[1]),
    };
  }
  const editorMatch = path.match(/^\/editor\/([^/]+)$/);
  if (editorMatch) {
    const siteId = decodeURIComponent(editorMatch[1]);
    const preview =
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('preview') === '1';
    return preview ? { kind: 'editor', siteId, preview: true } : { kind: 'editor', siteId };
  }
  const reviewMatch = path.match(/^\/review\/([^/]+)$/);
  if (reviewMatch) {
    return { kind: 'review', token: decodeURIComponent(reviewMatch[1]) };
  }
  return { kind: 'login' };
}

export function navigate(path: string): void {
  window.location.assign(path);
}
